/* Copyright (c) 2020-present CloudIO Inc */

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { BaseProps, DevProps } from 'componentregistry';

const EMPTY_OBJECT = {};

export function extractDevProps(props: BaseProps<any>): Partial<DevProps> {
  const { onClick, onMouseEnter, onMouseLeave, onContextMenu } = props;
  if (onClick && onMouseEnter && onMouseLeave && onContextMenu) {
    return { onClick, onMouseEnter, onMouseLeave, onContextMenu };
  }
  return EMPTY_OBJECT;
}

export function excludeNonDOMProps(
  props: Partial<BaseProps<any>>,
): Omit<
  BaseProps<any>,
  | 'appUid'
  | 'roleUid'
  | 'children'
  | 'comments'
  | 'cssClassName'
  | 'domProps'
  | 'initial'
  | 'itemId'
  | 'itemType'
  | 'layoutId'
  | 'onLayoutAnimationComplete'
  | 'pageId'
  | 'platform'
  | 'responsive'
  | 'transformTemplate'
  | 'visible'
  | 'visibleCondition'
> {
  const {
    // remove all non dom props... DO NOT REMOVE THESE AS UNUSED VARIABLES
    appUid,
    roleUid,
    children,
    comments,
    cssClassName,
    domProps,
    initial,
    itemId,
    itemType,
    layoutId,
    onLayoutAnimationComplete,
    pageId,
    platform,
    responsive,
    transformTemplate,
    visible,
    visibleCondition,
    // remove all non dom props... DO NOT REMOVE THESE AS UNUSED VARIABLES
    ...otherProps
  } = props;
  return otherProps;
}
